import { useFetchSampleDescriptions } from '@modules/integrationsV2/hooks/useFetchSampleDescriptions';
import { Chip, Skeleton, Stack, Typography } from '@mui/material';

interface IntegrationDescriptionSampleTemplatesProps {
  description: string;
  onSelect: (description: string) => void;
}

export const IntegrationDescriptionSampleTemplates = ({
  description,
  onSelect,
}: IntegrationDescriptionSampleTemplatesProps) => {
  const { sampleDescriptions, isLoading } = useFetchSampleDescriptions();

  if (!isLoading && !sampleDescriptions.length) {
    return null;
  }

  const renderSampleDescriptions = () => {
    if (isLoading) {
      return Array.from({ length: 4 }).map((_, index) => (
        <Skeleton
          variant="rounded"
          key={index}
          width={130}
          height={20}
          sx={{
            borderRadius: 10,
          }}
        />
      ));
    }

    return sampleDescriptions.map((template) => {
      const isSelected = template.description === description;

      return (
        <Chip
          key={template.name}
          label={template.name}
          size="small"
          variant={isSelected ? 'filled' : 'outlined'}
          onClick={() => onSelect(template.description)}
        />
      );
    });
  };

  return (
    <Stack spacing={1}>
      <Typography variant="caption" color="text.secondary">
        Explore these templates:
      </Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        {renderSampleDescriptions()}
      </Stack>
    </Stack>
  );
};
